import { ReactElement } from 'react'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'
import PorcentagemTransferencia from '../../pages/PorcentagemTransferencia'
import UpdatePercentualTransferenciaMotoristaImpl from '../../domain/usecases/UpdatePercentualTransferenciaMotorista'
import GetPercentualTransferenciaMotoristaImpl from '../../domain/usecases/GetPercentualTransferenciaMotorista'

export const PorcentagemTransferenciaFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const getPercentualTransferenciaMotoristaImpl =
    new GetPercentualTransferenciaMotoristaImpl(pagamentoRepository)
  const updatePercentualTransferenciaMotoristaImpl =
    new UpdatePercentualTransferenciaMotoristaImpl(pagamentoRepository)

  return (
    <PorcentagemTransferencia
      updatePercentualTransferenciaMotorista={
        updatePercentualTransferenciaMotoristaImpl
      }
      getPercentualTransferenciaMotorista={
        getPercentualTransferenciaMotoristaImpl
      }
    />
  )
}
